/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useEffect } from 'react';
import Model, { helper } from '@tripian/model';
import NumberInput from '../../base/NumberInput/NumberInput';
import Dropdown from '../../base/Dropdown/Dropdown';
import QuestionTemplate from '../../QuestionTemplate/QuestionTemplate';
import classes from './FormTemplateCompanion.scss';
import Input from '../../base/Input/Input';

interface IFormTemplateCompanion {
  questions: Array<Model.Question>;
  userCompanion: Model.Companion;
  callbackFormTemplateCompanion: (userCompanion: Model.Companion) => void;
  t: (value: Model.TranslationKey) => string;
}

const FormTemplateCompanion: React.FC<IFormTemplateCompanion> = ({ questions, userCompanion, callbackFormTemplateCompanion, t }) => {
  const nameInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    nameInputRef.current?.focus();
  }, []);

  const callbackName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newCompanionState = helper.deepCopy(userCompanion);
    newCompanionState.name = event.target.value;
    callbackFormTemplateCompanion(newCompanionState);
  };

  const callbackNumber = (num: number | null) => {
    const newCompanionState = helper.deepCopy(userCompanion);
    newCompanionState.age = num || 0;
    callbackFormTemplateCompanion(newCompanionState);
  };

  const userCompanionQuestionOnChange = (selectedAnswers: Array<number>) => {
    const newCompanionState = helper.deepCopy(userCompanion);
    newCompanionState.answers = selectedAnswers;
    callbackFormTemplateCompanion(newCompanionState);
  };

  const callbackTitle = (value: React.ReactText) => {
    const newCompanionState = helper.deepCopy(userCompanion);
    newCompanionState.title = value as string;
    callbackFormTemplateCompanion(newCompanionState);
  };

  return (
    <>
      <div className="row">
        <div className="col col12 my2">
          <h4 className={classes.header}>{t('user.travelCompanions.companionTitle')}</h4>
          <Dropdown options={helper.companionTitleOptions} defaultValue={userCompanion.title} selectChange={callbackTitle} />
        </div>
      </div>
      {/* <div className="row m0 mb2">
        <div className="col col12 my2 col5-m">
          <h4 className={classes.header}>{t('user.travelCompanions.companionName')}</h4>
          <TextField name="name" value={userCompanion.name} onChange={callbackName} style={{ marginRight: '1rem' }} />
        </div>
        <div className="col col2 hide-s" />
        <div className="col col12 my2 col5-m">
          <h4 className={classes.header}>{t('user.travelCompanions.companionAge')}</h4>
          <NumberInput minValue={1} maxValue={100} defaultValue={userCompanion.age} onchange={callbackNumber} />
        </div>
      </div> */}

      <div className="row mb0">
        <div className="col col12 col6-m p0">
          <div className="col col12 my2">
            <h4 className={classes.header}>{t('user.travelCompanions.companionName')}</h4>
          </div>
          <div className="col col12">
            <Input ref={nameInputRef} type="text" placeholder={t('user.travelCompanions.companionName')} name="name" value={userCompanion.name} onChange={callbackName} />
          </div>
        </div>
        <div className="col col12 col6-m p0">
          <div className="col col12 my2">
            <h4 className={classes.header}>{t('user.travelCompanions.companionAge')}</h4>
          </div>
          <div className="col col12">
            <NumberInput minValue={1} maxValue={100} defaultValue={userCompanion.age} onchange={callbackNumber} />
            {/* <Input type="number" min={1} max={100} placeholder={t('user.travelCompanions.companionAge')} name="age" value={userCompanion.age} onChange={(e) => callbackNumber(Number(e.target.value))} /> */}
          </div>
        </div>
      </div>
      <div className="row m0 mb2">
        {questions.map((question) => (
          <div key={question.id} className={`${classes.questionWrapper} col col12`}>
            <QuestionTemplate question={question} answers={userCompanion.answers} callbackAnswers={userCompanionQuestionOnChange} />
          </div>
        ))}
      </div>
    </>
  );
};

export default FormTemplateCompanion;
